import { Link } from "react-router-dom";
import { PHONE, EMAIL } from "@/mocks/updiag";
import { SHOW_REVIEWS } from "@/config/features";

const footerServices = [
  { label: "DPE — Service phare", href: "/diagnostics/dpe" },
  { label: "Pack Vente (DDT)", href: "/diagnostics/pack-vente" },
  { label: "Pack Location", href: "/diagnostics/pack-location" },
  { label: "Diagnostic Amiante", href: "/diagnostics/amiante" },
  { label: "Diagnostic Plomb", href: "/diagnostics/plomb" },
  { label: "Diagnostic Électricité", href: "/diagnostics/electricite" },
  { label: "Diagnostic Gaz", href: "/diagnostics/gaz" },
  { label: "Loi Carrez", href: "/diagnostics/loi-carrez" },
];

const footerZones = [
  { label: "Paris (75)", href: "/zones/paris-75" },
  { label: "Hauts-de-Seine (92)", href: "/zones/hauts-de-seine-92" },
  { label: "Seine-Saint-Denis (93)", href: "/zones/seine-saint-denis-93" },
  { label: "Val-de-Marne (94)", href: "/zones/val-de-marne-94" },
  { label: "Yvelines (78)", href: "/zones/yvelines-78" },
  { label: "Essonne (91)", href: "/zones/essonne-91" },
  { label: "Seine-et-Marne (77)", href: "/zones/seine-et-marne-77" },
  { label: "Val-d'Oise (95)", href: "/zones/val-d-oise-95" },
];

const footerResources = [
  { label: "Nos tarifs", href: "/tarifs" },
  { label: "Avis clients", href: "/avis" },
  { label: "Blog & Conseils", href: "/blog" },
  { label: "À propos", href: "/a-propos" },
  { label: "Devis en ligne", href: "/devis" },
  { label: "Contact", href: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0F3B5F] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Col 1 — À propos */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center">
                <i className="ri-home-gear-fill text-white text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-xl leading-none" style={{ fontFamily: "Barlow, sans-serif" }}>Up Diag</div>
                <div className="text-[10px] text-white/60 leading-none mt-0.5">Diagnostic immobilier certifié</div>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed mb-5">
              Votre expert en diagnostic immobilier à Paris et en Île-de-France. Certifié COFRAC, RDV sous 48h, rapport le jour même.
            </p>
            <div className="flex flex-col gap-2 text-sm text-white/70">
              <div className="flex items-center gap-2">
                <i className="ri-award-fill text-[#F97316]"></i>
                <span>Certifié COFRAC</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-fill text-[#16A34A]"></i>
                <span>RC Pro assurée</span>
              </div>
              {SHOW_REVIEWS && (
                <div className="flex items-center gap-2">
                  <i className="ri-star-fill text-[#F59E0B]"></i>
                  <span>4.9/5 — 127 avis Google</span>
                </div>
              )}
            </div>
          </div>

          {/* Col 2 — Services */}
          <div>
            <h3 className="font-bold text-base mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>Nos diagnostics</h3>
            <ul className="flex flex-col gap-2.5">
              {footerServices.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-sm text-white/70 hover:text-[#F97316] transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Zones */}
          <div>
            <h3 className="font-bold text-base mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>Zones d'intervention</h3>
            <ul className="flex flex-col gap-2.5">
              {footerZones.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-sm text-white/70 hover:text-[#F97316] transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Ressources */}
          <div>
            <h3 className="font-bold text-base mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>Ressources</h3>
            <ul className="flex flex-col gap-2.5">
              {footerResources.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-sm text-white/70 hover:text-[#F97316] transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 5 — Contact */}
          <div>
            <h3 className="font-bold text-base mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>Contact</h3>
            <div className="flex flex-col gap-4">
              <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="flex items-start gap-3 text-sm text-white/70 hover:text-[#F97316] transition-colors">
                <i className="ri-phone-fill text-[#F97316] mt-0.5"></i>
                <span>{PHONE}</span>
              </a>
              <a href={`mailto:${EMAIL}`} className="flex items-start gap-3 text-sm text-white/70 hover:text-[#F97316] transition-colors">
                <i className="ri-mail-fill text-[#F97316] mt-0.5"></i>
                <span>{EMAIL}</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <i className="ri-map-pin-2-fill text-[#F97316] mt-0.5"></i>
                <span>Paris &amp; Île-de-France<br />Intervention à domicile</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <i className="ri-time-fill text-[#F97316] mt-0.5"></i>
                <span>Lun–Sam : 8h–19h<br />Dimanche sur RDV</span>
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              {["ri-google-fill", "ri-facebook-fill", "ri-linkedin-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/60 transition-all duration-200"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            © 2025 Up Diag — Diagnostic immobilier Paris &amp; Île-de-France. Tous droits réservés.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/mentions-legales" className="text-xs text-white/50 hover:text-white/80 transition-colors">Mentions légales</Link>
            <a href="#" className="text-xs text-white/50 hover:text-white/80 transition-colors">CGV</a>
            <a href="#" className="text-xs text-white/50 hover:text-white/80 transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
